/**
 * Wizard video data. Note: must use FYM_WIZARDS_BACKEND_URL endpoint.
 */
export const wizardVideo = `
 query getWizardVideo{
     video {
       version
       url
       hasViewed
       questions
       answers
       progress
       duration
       isFirstTime
       completedViewAt
       createdAt
     }
   }
 `;
